// extracted by mini-css-extract-plugin
export default {"category":"category_category__g3WAx","link":"category_link__N1ZBJ","img":"category_img__j4mXi","shadow":"category_shadow__eYxI4"};